import {
  BettingV2CommandStateRecord,
  bettingV2CommandStateDefaultState,
  state$,
} from '@core/Areas/RaceCard/Components/RaceCardContent/Components/LegacyKnockout/ViewModels/Betting-v2/Components/Commands/driver'
import { useObservable } from '@core/Utils/hooks'

export function useCommandState(): BettingV2CommandStateRecord {
  return useObservable(state$, bettingV2CommandStateDefaultState)
}
